import { getSessionStorage } from '/@/utils/storage'
export function completionUrl(url, domain = '') {
  // 如果是开发环境，在没有使用阿里云的情况下，用VITE_HOST
  // 如果url中有http 则不拼
  if (url && url.indexOf('http') > -1) {
    return url
  } else if (domain) {
    return domain + url
  } else {
    const ossData = getSessionStorage('oss')
    const system = getSessionStorage('system')
    if (ossData) {
      if (ossData.type === 'default') {
        return system.domain + url
      } else {
        const oss = ossData.oss[ossData.type]
        return oss.domain + url
      }
    }
    return url
  }
}

export const changeSet = (arr) => {
  let obj = {}
  arr.forEach(item => {
    const data = {}
    item.form.forEach(items => {
      items.formItem.forEach(fitem => {
        data[fitem.key] = fitem.value
      })
    })
    obj = Object.assign(obj, data)
  })
  return obj
}

export const changeTree = (arr) => {
  const result = []
  if (!Array.isArray(arr)) return result
  const map = {}
  // 以id为键，转成对象
  arr.forEach(item => {
    map[item.id] = item
  })
  arr.forEach(item => {
    // 当pid为0时则为顶级分类，直接push到result
    const parent = map[item.pid]
    if (parent) {
      (parent.children || (parent.children = [])).push(item)
    } else {
      result.push(item)
    }
  })
  return result
}

// 获取table高度
export const getTableHeight = (height = 260) => {
  const tableHeight = document.body.clientHeight - height
  return tableHeight < 330 ? '330px' : `${tableHeight}px`
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

const getFormKeyValue = (comp) => {
  const data = {}
  comp.form.forEach(item => {
    item.formItem.forEach(fitem => {
      data[fitem.key] = fitem.value
    })
  })
  return data
}

export { getFormKeyValue }

// 深度克隆
export function deepClone(obj) {
  // 对常见的“非”值，直接返回原来值
  if ([null, undefined, NaN, false].includes(obj)) {
    return obj
  }
  if (typeof obj !== 'object' && typeof obj !== 'function') {
    // 原始类型直接返回
    return obj
  }
  const o = Array.isArray(obj) ? [] : {}
  for (const i in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, i)) {
      o[i] = typeof obj[i] === 'object' ? deepClone(obj[i]) : obj[i]
    }
  }
  return o
}
// 删除路由tag
export function closeTab(that) {
  that.$store.dispatch('tag/removeTag', that.$route)
  const tag = that.$store.state.tag.routeTag || []
  let path = '/'
  if (tag.length) {
    path = tag[tag.length - 1]['fullPath']
  }
  that.$router.push(path)
}
